// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../../shared/components/checkbox-list-with-label';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import ToggleCheckboxesButton from '../../../../shared/components/toggle-checkboxes-button';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';
import {getSelectAllText} from '../../../shared/services/criteria';

const TerritoryCriteria = props => {

    const territorySelectionMessage = getSelectAllText(props.selectedTerritories);

    return (
        <div className='territory-criteria'>
            <CheckboxListWithLabel
                className='audit-summary-territories'
                initialState={createHashMap(props.selectedTerritories, 'territory')}
                isRequired={true}
                label='TERRITORY'
                list={addCollectionLabels(props.allowedTerritories, 'territory')}
                onChange={props.onSelectTerritory}
                uid='territory'
            />
            <ToggleCheckboxesButton
                label={territorySelectionMessage}
                listLength={props.allowedTerritories.length}
                onClick={props.onSelectAllTerritories}
            />
        </div>);

};

TerritoryCriteria.displayName = 'TerritoryCriteria';
TerritoryCriteria.propTypes = {
    allowedTerritories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired,
    onSelectAllTerritories: PropTypes.func.isRequired,
    onSelectTerritory: PropTypes.func.isRequired,
    selectedTerritories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired
};

export default TerritoryCriteria;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/components/audit-summary-report-criteria/territory-criteria.js